"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AccordionSize: function() {
        return _accordionItem.AccordionSize;
    },
    AccordionItemChildrenProps: function() {
        return _accordionItem.AccordionItemChildrenProps;
    },
    Accordion: function() {
        return Accordion;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
var _classnames = /*#__PURE__*/ _interopRequireDefault(require("classnames"));
var _accordionItem = /*#__PURE__*/ _interopRequireWildcard(require("./AccordionItem"));
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Accordion = function(param) {
    var items = param.items, className = param.className, _param_size = param.size, size = _param_size === void 0 ? _accordionItem.AccordionSize.BIG : _param_size, _param_defaultActive = param.defaultActive, defaultActive = _param_defaultActive === void 0 ? 0 : _param_defaultActive, _param_fullWidth = param.fullWidth, fullWidth = _param_fullWidth === void 0 ? false : _param_fullWidth, onActiveItemChange = param.onActiveItemChange;
    var _useState = _slicedToArray((0, _react.useState)(defaultActive), 2), activeItem = _useState[0], setActiveItem = _useState[1];
    var getNextActive = function() {
        var current = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : activeItem;
        if (current >= items.length - 1) return current;
        var newIndex = Math.min(items.length - 1, current + 1);
        return items[newIndex].disabled ? getNextActive(newIndex) : newIndex;
    };
    var getPreviousActive = function() {
        var current = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : activeItem;
        if (current >= items.length - 1) return current;
        var newIndex = Math.max(0, current - 1);
        return items[newIndex].disabled ? getPreviousActive(newIndex) : newIndex;
    };
    var onHeaderClick = function(event, stepId, position) {
        var newActiveItemIndex = activeItem === position ? -1 : position;
        setActiveItem(newActiveItemIndex);
        if (newActiveItemIndex >= 0) {
            onActiveItemChange && onActiveItemChange(event, stepId, newActiveItemIndex);
        }
    };
    var openPreviousItem = function() {
        return setActiveItem(getPreviousActive(activeItem));
    };
    var openNextItem = function() {
        return setActiveItem(getNextActive(activeItem));
    };
    (0, _react.useEffect)(function() {
        setActiveItem(defaultActive);
    }, [
        defaultActive
    ]);
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: (0, _classnames.default)("flex flex-col border border-gray-200 rounded-md divide-y divide-solid divide-gray-200", className)
    }, items.map(function(item, index) {
        return /*#__PURE__*/ _react.default.createElement(_accordionItem.default, _extends({}, item, {
            key: index,
            position: index,
            size: size,
            onHeaderClick: onHeaderClick,
            openNextItem: openNextItem,
            openPreviousItem: openPreviousItem,
            active: activeItem === index,
            fullWidth: fullWidth
        }));
    }));
};

//# sourceMappingURL=Accordion.js.map